import { useMutation, useQuery } from "@tanstack/react-query";
import { useStore } from "../../../../helpers";
import { useParams } from "react-router-dom";
import { safe_get } from "../../../../report-visuals";
import { toast } from "react-toastify";

type FormData = {
  projectid: number;
  task_string: string;
};

const useCMDFormFunctions = () => {
  const {
    projectStore,
    taskManagerStore: {
      setActiveAssignTaskTab,
      setBulkAssignTaskList,
      set_users,
    },
    apiRequestHandler,
  } = useStore();
  const { projectid } = useParams();
  const { mutateAsync: submitCMDTasks } = useMutation({
    mutationKey: ["submitCMDTasks"],
    mutationFn: async (formData: FormData) =>
      await apiRequestHandler(
        "/tfv2/task_command",
        formData,
        "Something went wrong while submitting tasks"
      ),
  });
  const fetch_users = async () => {
    const payload = {
      projectid: parseInt(projectid),
      tags: [],
      query: "",
      limit: 500,
      offset: 0,
    };
    const res = await projectStore.getAllUsers(payload);
    if (res.status === 200) {
      set_users(safe_get(res.data, "users", []));
    } else {
      toast.error("Users are not loaded, please refresh the page.");
    }
  };
  const onSubmit = async (formData) => {
    const response = await submitCMDTasks({
      projectid: parseInt(projectid),
      task_string: formData.commands,
    });
    // await fetch_users();
    const taskList = (await response?.data) || [];
    console.log("data", taskList);
    setBulkAssignTaskList(taskList);
  };
  const onError = (error) => {
    console.log("Assign Tasks error");
    console.log(error);
  };

  return { setActiveAssignTaskTab, onSubmit, onError };
};

export default useCMDFormFunctions;
